import DataModule from "@/components/DataModule";
import { inr } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { MEASURING_UNITS } from "@/lib/units";

export default function Products() {
  return (
    <DataModule
      title="Products"
      subtitle="Inventory items with GST, HSN, SKU, stock"
      endpoint="products"
      pageTestId="products-page"
      initialRecord={{ current_stock: 0, min_stock: 0, gst_percent: 18 }}
      fields={[
        { key: "name", label: "Product Name", required: true },
        { key: "sku", label: "SKU" },
        { key: "barcode", label: "Barcode" },
        { key: "hsn", label: "HSN Code" },
        { key: "category", label: "Category" },
        { key: "brand", label: "Brand" },
        { key: "unit", label: "Unit", type: "select", options: MEASURING_UNITS },
        { key: "gst_percent", label: "GST %", type: "number" },
        { key: "purchase_price", label: "Purchase Price", type: "number" },
        { key: "selling_price", label: "Selling Price", type: "number" },
        { key: "mrp", label: "MRP", type: "number" },
        { key: "current_stock", label: "Current Stock", type: "number" },
        { key: "min_stock", label: "Min Stock", type: "number" },
        { key: "warehouse", label: "Warehouse" },
        { key: "description", label: "Description", type: "textarea", full: true },
      ]}
      columns={[
        { key: "name", label: "Name", render: (p) => (
          <div>
            <div className="font-medium">{p.name}</div>
            <div className="text-xs text-muted-foreground">{p.sku || p.barcode || ""}</div>
          </div>
        )},
        { key: "hsn", label: "HSN" },
        { key: "selling_price", label: "Price", render: (p) => inr(p.selling_price) },
        { key: "gst_percent", label: "GST", render: (p) => `${p.gst_percent || 0}%` },
        { key: "current_stock", label: "Stock", render: (p) => {
          const low = (p.current_stock || 0) < (p.min_stock || 0);
          return <Badge variant={low ? "destructive" : "secondary"}>{p.current_stock || 0} {p.unit || ""}</Badge>;
        }},
      ]}
    />
  );
}
